import * as Yup from 'yup';
import { TIMEZONE_VN } from 'constant';

const createProgramValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(80, () => 'program.validationErrors.programNameAtMost80Character')
    .required('program.validationErrors.nameRequired'),
  description: Yup.string().required('program.validationErrors.descriptionRequired'),
  startTime: Yup.string()
    .test({
      name: 'endTime',
      exclusive: false,
      params: {},
      message: 'program.validationErrors.startingTimeBeforeEndingTimeRequired',
      test: (value, context) => {
        const { endTime } = context.parent;
        if (!endTime) return true;

        const endTimeDate = new Date(endTime).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        const startingTimeDate = new Date(value).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        return startingTimeDate < endTimeDate;
      },
    })
    .required('program.validationErrors.startingTimeRequired')
    .nullable(),
  endTime: Yup.string()
    .test({
      name: 'startTime',
      exclusive: false,
      params: {},
      message: 'program.validationErrors.endingTimeAfterStartingTimeRequired',
      test: (value, context) => {
        const { startTime } = context.parent;
        if (!startTime) return true;

        const startTimeDate = new Date(startTime).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        const endTimeDate = new Date(value).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        return startTimeDate < endTimeDate;
      },
    })
    .required('program.validationErrors.endingTimeRequired')
    .nullable(),
});

export default createProgramValidationSchema;
